import React from "react";
import HeaderMain from "./HeaderMain";

const HeaderMainContainer = React.memo(({...props}) => {
  return <HeaderMain {...props } />
});

export default HeaderMainContainer;
